import { Avatar, Box, Icon } from '@mui/material';
import { FC, ReactNode } from 'react';

import {
  ContactDetailsTooltip,
  ContactDetailsTooltipProps,
} from '../../../../components/common/ContactDetailsTooltip/ContactDetailsTooltip';

type AssignedProductPayerProps = {
  icon: ReactNode;
  onClick?: () => void;
} & Omit<ContactDetailsTooltipProps, 'children'>;

export const AssignedProductPayer: FC<AssignedProductPayerProps> = ({
  icon,
  onClick,
  ...props
}) => {
  return (
    <ContactDetailsTooltip {...props}>
      <Box onClick={onClick}>
        <Avatar>
          <Icon fontSize="small" sx={{ color: 'primary.main' }}>
            {icon}
          </Icon>
        </Avatar>
      </Box>
    </ContactDetailsTooltip>
  );
};
